import ru from '@/internationalization/trans/chefs/ru/ru.json';
export default {
  trans: ru,
};
